import { Api } from "../config/request";

export default {
  getRiderOffers(payload) {
    payload = transformPayload(payload);
    payload["type"] = "active";
    payload["app_code"] = 100009;
    return Api.post(`/offers/data`, payload);
  },
};

function transformPayload(payload) {
  const driverId = payload["driver_id"];
  if (isNaN(driverId)) {
    payload["driver_id"] = driverId.substring(2) - 10000;
  }
  payload["driver_id"] = Number(payload["driver_id"]);
  return payload;
}
